import { Map } from "mapbox-gl";

export class MapHelper {
    private _map: Map;

    public constructor(map: Map) {
        this._map = map;
    }

    public addModelToMap = (
        model: string,
        modelLocation: [number, number][][],
        center: [number, number],
        modelRotation: [number, number, number],
        modelScale: [number, number, number],
        isShowLocation: boolean = false
    ) => {
        this._map.addSource('eraser', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            coordinates: modelLocation,
                            type: 'Polygon'
                        }
                    }
                ]
            }
        });
        this._map.addSource('model', {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {
                    'model-uri': model
                },
                geometry: {
                    coordinates: center,
                    type: 'Point'
                }
            }
        });

        this._map.addLayer({
            id: 'eraser',
            type: 'clip',
            source: 'eraser',
            layout: {
                'clip-layer-types': ['symbol', 'model'],
                'clip-layer-scope': ['basemap']
            }
        });
        this._map.addLayer({
            id: 'tower',
            type: 'model',
            slot: 'middle',
            source: 'model',
            minzoom: 10,
            layout: {
                'model-id': ['get', 'model-uri']
            },
            paint: {
                'model-opacity': 1,
                'model-rotation': modelRotation,
                'model-scale': modelScale,
                'model-color-mix-intensity': 0,
                'model-cast-shadows': true,
                'model-emissive-strength': 1
            }
        });

        if (isShowLocation) {
            this._map.addLayer({
                id: 'eraser-debug',
                type: 'line',
                source: 'eraser',
                paint: {
                    'line-color': 'rgba(255, 0, 0, 0.9)',
                    'line-dasharray': [0, 4, 3],
                    'line-width': 5
                }
            });
        }
    };

    public enableClickDebug = () => {
        this._map.on('click', (e) => {
            console.log(e);
        });
    };
}